<template>
<div>
    <p>
        <span v-show="isSpaceLimitExceeded">
            <i class="fas fa-exclamation has-text-danger"></i>
        </span>
        <span v-html="text"></span>
    </p>
    <progress
        class="progress"
        :class="progressClass"
        :value="percents"
        max="100"
    >
        {{ percents }}
    </progress>
</div>
</template>

<script>
export default {
    name: "DiskSpaceIndicator",
    props: {
        msg: String,
        measures: String,
        totalSpace: {
            type: Number,
            default: 0
        },
        usedSpace: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        text() {
            return this.replaceWildcards(this.msg, {
                space_used: this._humanFileSize(this.usedSpace, this.measures),
                space_total: this._humanFileSize(this.totalSpace, this.measures),
            })
        },
        percents() {
            return this.usedSpace * 100 / this.totalSpace;
        },
        isSpaceLimitExceeded() {
            return this.usedSpace > this.totalSpace;
        },
        progressClass() {
            return this.isSpaceLimitExceeded ? 'is-danger' : 'is-link';
        },
    }
}
</script>

<style scoped>
    .progress {
        height: 0.35rem;
        margin-top: 0.3rem;
    }

    .fa-exclamation {
        margin-right: 0.2rem;
    }
</style>